import moment from "moment";
import React, { useEffect, useState } from "react";
import MainDatatable from "../../components/datatable/MainDatatable.jsx";
import DatatableHeading from "../../components/datatable/DatatableHeading.jsx";
import { DeepSearchSpace } from "../../utils/common-function/index.js";
import { api_urls } from "../../utils/api-urls/index.js";

const Reports = () => {
    const [loading, setLoading] = useState(false);
    const [rechargeStats, setRechargeStats] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [dateRange, setDateRange] = useState({
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    });

    const filteredData = DeepSearchSpace(rechargeStats, searchText);

    const columns = [
        { name: 'S.No.', selector: (row, index) => index + 1, width: '80px' },
        { name: 'Date', selector: row => row?.date ? moment(row?.date).format('DD MMM YYYY') : 'N/A', width: '130px' },
        { name: 'Total Recharges', selector: row => row?.totalCount || 0, width: '140px' },
        { name: 'Success', selector: row => row?.successCount || 0, width: '100px' },
        { name: 'Failed', selector: row => row?.failedCount || 0, width: '100px' },
        { name: 'Cancelled', selector: row => row?.cancelledCount || 0, width: '110px' },
        { name: 'Total Amount', selector: row => '₹' + (row?.totalAmount || 0).toFixed(2), width: '130px' },
        { name: 'Success Amount', selector: row => '₹' + (row?.successAmount || 0).toFixed(2), width: '140px' },
        { name: 'A1TOPUP', selector: row => row?.a1topupCount || 0, width: '100px' },
        { name: 'PAY2NEW', selector: row => row?.pay2newCount || 0, width: '100px' },
    ];

    const fetchReports = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${api_urls}api/recharge/daily-stats?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`);
            const data = await response.json();
            if (data?.success) {
                setRechargeStats(data?.stats || []);
            }
        } catch (error) {
            console.error('Error fetching reports:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReports();
    }, [dateRange]);

    const totalStats = rechargeStats.reduce((acc, item) => ({
        totalCount: acc.totalCount + (item?.totalCount || 0),
        successCount: acc.successCount + (item?.successCount || 0),
        failedCount: acc.failedCount + (item?.failedCount || 0),
        totalAmount: acc.totalAmount + (item?.totalAmount || 0),
        successAmount: acc.successAmount + (item?.successAmount || 0),
        a1topupCount: acc.a1topupCount + (item?.a1topupCount || 0),
        pay2newCount: acc.pay2newCount + (item?.pay2newCount || 0),
    }), { totalCount: 0, successCount: 0, failedCount: 0, totalAmount: 0, successAmount: 0, a1topupCount: 0, pay2newCount: 0 });

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <DatatableHeading title="Recharge Reports" data={rechargeStats} />

                {/* Summary Cards */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', marginBottom: '20px' }}>
                    <div style={{ padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', minWidth: '150px' }}>
                        <div style={{ fontSize: '12px', color: '#666' }}>Total Recharges</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1976d2' }}>{totalStats.totalCount}</div>
                    </div>
                    <div style={{ padding: '15px', backgroundColor: '#e8f5e9', borderRadius: '8px', minWidth: '150px' }}>
                        <div style={{ fontSize: '12px', color: '#666' }}>Successful</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#388e3c' }}>{totalStats.successCount}</div>
                    </div>
                    <div style={{ padding: '15px', backgroundColor: '#ffebee', borderRadius: '8px', minWidth: '150px' }}>
                        <div style={{ fontSize: '12px', color: '#666' }}>Failed</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#d32f2f' }}>{totalStats.failedCount}</div>
                    </div>
                    <div style={{ padding: '15px', backgroundColor: '#fff3e0', borderRadius: '8px', minWidth: '150px' }}>
                        <div style={{ fontSize: '12px', color: '#666' }}>Total Amount</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#f57c00' }}>₹{totalStats.totalAmount.toFixed(2)}</div>
                    </div>
                    <div style={{ padding: '15px', backgroundColor: '#f3e5f5', borderRadius: '8px', minWidth: '150px' }}>
                        <div style={{ fontSize: '12px', color: '#666' }}>A1TOPUP</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#7b1fa2' }}>{totalStats.a1topupCount}</div>
                    </div>
                    <div style={{ padding: '15px', backgroundColor: '#e0f7fa', borderRadius: '8px', minWidth: '150px' }}>
                        <div style={{ fontSize: '12px', color: '#666' }}>PAY2NEW</div>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#00838f' }}>{totalStats.pay2newCount}</div>
                    </div>
                </div>

                {/* Date Filters */}
                <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", alignItems: 'center', marginBottom: "20px" }}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <label>From:</label>
                        <input 
                            type='date' 
                            value={dateRange.startDate} 
                            onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))} 
                            style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc' }} 
                        />
                        <label>To:</label>
                        <input 
                            type='date' 
                            value={dateRange.endDate} 
                            onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))} 
                            style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc' }} 
                        />
                    </div>
                    <input 
                        type='search' 
                        value={searchText} 
                        onChange={(e) => setSearchText(e.target.value)} 
                        placeholder='Search...' 
                        style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc', width: '100%', maxWidth: '250px', fontSize: '15px' }} 
                    />
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>
                ) : (
                    <MainDatatable columns={columns} data={filteredData} />
                )}
            </div>
        </>
    );
};

export default Reports;
